import React, { useState, useEffect } from 'react'
import "./viewAllUsers.css"
import Nav from '../../globalComponents/nav/Nav';
import Footer from '../../globalComponents/footer/Footer';
import { useNavigate, useParams } from 'react-router-dom';
import { MDBAccordion, MDBAccordionItem, MDBBtn } from 'mdb-react-ui-kit';
import Url from '../url'

function ViewAllUsers() {
    const navigate = useNavigate()
    const [token, setToken] = useState(null)
    const [currentUserEmail, setCurrentUserEmail] = useState(undefined)
    const [admin, setAdmin] = useState(null)
    const [tokenLoaded, setTokenLoaded] = useState(false)
    const [allUsersLoaded, setAllUsersLoaded] = useState(false)
    const [allUsers, setAllUsers] = useState([])


    useEffect(() => {
        if (localStorage.getItem("user")) {

            setCurrentUserEmail(localStorage.getItem("user"))
            localStorage.getItem("token")[3] == "Y" ? setAdmin(true) : setAdmin(false)
            setToken(localStorage.getItem("token").slice(0, 3) + localStorage.getItem("token").slice(4))
            setTokenLoaded(true)
        }
    }, [])

    useEffect(() => {
        if (token && !allUsersLoaded) {
            console.log(`fetching with token ` + token)
            
            fetch(Url+`user/getAllUsers`, {
                method: "GET",
                body: null,
                headers: new Headers({
                    "Content-Type": "application/json",
                    "authorization": token
                })

            })
                .then(res => res.json())
                .then(data => {
                    if (data.error) {
                        alert(`${data.error}`)
                    }
                    else {
                        console.log(data.usersWithProjects)
                        setAllUsers(data.usersWithProjects)
                        setAllUsersLoaded(true)
                    }
                })
                .catch(err => { console.log(err) })
        }
    }, [token])

    return (
        <>
        <Nav></Nav>
        { allUsersLoaded &&
        <div className='container-sm' style={{marginTop:"120px"}}>
            <h3>All users</h3>
            <MDBAccordion initialActive={0} alwaysOpen>
                {allUsersLoaded 
                    ? allUsers.map((item,key)=>{
                        return (
                            <MDBAccordionItem collapseId={key+1} 
                                key={item.user._id}                
                                headerTitle={
                                    <div className='container-lg'>
                                        <div className='row'>
                                            <div className='col-md-2'>
                                                <strong>{item.user.fName} {item.user.lName}</strong>
                                            </div>

                                            <div className='col-md-3'>
                                                <i>Project: </i>
                                                {item.createdProject 
                                                            ? item.createdProject.projectName 
                                                            : "None"}
                                            </div>
                                        </div>
                                    </div>
                                }>
                                            
                                            <div className='row'>
                                                <div className='col-2'>
                                                    <img className='img-thumbnail' src={item.user.avatar? item.user.avatar : null} alt="avatar image"  />
                                                </div>
                                                
                                                <div className='col-6'>
                                                        <p><small><i>User Name:</i></small> {item.user.email}</p>
                                                        <p><small><i>About Me:</i></small> {item.user.aboutMe}</p>
                                                        <p><small><i>Country:</i></small> { item.user.country == "us" ? "United States":item.user.country}</p>
                                                        {item.user.state != "" && 
                                                            <p><small><i>State:</i></small> {item.user.state != ""? item.user.state : null}</p>
                                                        }
                                                        {item.user.raverlyAccount !="" && 
                                                            <p><small><i>Raverly Account:</i></small> {item.user.raverlyAccount}</p>
                                                        }
                                                        <p><small><i>User role:</i></small> {item.user.isAdmin ? "Administrator": "Normal user"}</p>
                                                        
                                                </div>

                                                <div className='col'>
                                                    <p><small><b>Skills:</b></small></p>
                                                    {item.user.allSkills.knitSkill != "" ? <div><small><i>Knitting: </i></small> {item.user.allSkills.knitSkill}</div>:null}
                                                    {item.user.allSkills.crochetSkill != "" ? <div><small><i>Crocheting: </i></small> {item.user.allSkills.crochetSkill}</div>:null}
                                                    {item.user.allSkills.quiltSkill != "" ? <div><small><i>Quilting: </i></small> {item.user.allSkills.quiltSkill}</div>:null}
                                                    {item.user.allSkills.embroiderySkill != "" ? <div><small><i>Embroidery: </i></small> {item.user.allSkills.embroiderySkill}</div>:null}
                                                    {item.user.allSkills.sewSkill != "" ? <div><small><i>Sewing: </i></small> {item.user.allSkills.sewSkill}</div>:null}
                                                    {item.user.allSkills.crossStitchSkill != "" ? <div><small><i>Cross Stitch: </i></small> {item.user.allSkills.crossStitchSkill}</div>:null}
                                                    {item.user.allSkills.weaveSkill != "" ? <div><small><i>Weaving/Tapestry: </i></small> {item.user.allSkills.weaveSkill}</div>:null}
                                                    {item.user.allSkills.weaveLoomSkill != "" ? <div><small><i>Weaving/Loom: </i></small> {item.user.allSkills.weaveLoomSkill}</div>:null}
                                                    {item.user.allSkills.laceSkill != "" ? <div><small><i>Lace: </i></small> {item.user.allSkills.laceSkill}</div>:null}
                                                    {item.user.allSkills.rugMakingSkill != "" ? <div><small><i>Rug-Making: </i></small> {item.user.allSkills.rugMakingSkill}</div>:null}
                                                </div>

                                                <div className='row-lg'>
                                                <button className='btn btn-primary' onClick={e=>navigate(`/userProfile/${item.user._id}`)}>Edit This User</button>
                                                </div>
                                            </div>

                            </MDBAccordionItem>

                        )
                    })
                    :<h1>Loading Users</h1>}


            </MDBAccordion>
        </div>
        }
        <div style={{marginTop:"300px"}}>

        </div>
        <Footer></Footer>
    </>
  )
}

export default ViewAllUsers